import { defineStore } from 'pinia';
import { Configurables } from '@/modules/deployment/types/Configurables';
import { Plan } from '@/modules/deployment/types/Plan';

export const useDeploymentStore = defineStore('deployment', {
  state: () => ({
    paymentParams: {},
    showPaymentModal: false,
    selectedDeployment: '',
    activePaymentPeriod: 'month',
    successMode: true,
    configurables: {
      gcp: {
        regions: [],
        sizes: [],
        features: [],
        providers: [],
        bundles: [],
      },
      'mock-cloud': {
        regions: [],
        sizes: [],
        features: [],
        providers: [],
        bundles: [],
      },
    },
    areConfigurablesReady: false,
    plans: [],
  } as { activePaymentPeriod: string, successMode: boolean, paymentParams: object, selectedDeployment: string, showPaymentModal: boolean, configurables: { gcp: Configurables, 'mock-cloud': Configurables }, areConfigurablesReady: boolean, plans: Plan[] }),
  actions: {
    setActivePaymentPeriod(period: string) {
      this.activePaymentPeriod = period;
    },
    setPaymentParams(params: object) {
      this.paymentParams = params;
    },
    setShowPaymentModal(show: boolean, successMode = false) {
      this.showPaymentModal = show;
      this.successMode = successMode;
    },
    setSuccessMode(successMode: boolean) {
      this.successMode = successMode;
    },
    setSelectedDeployment(id: string) {
      this.selectedDeployment = id;
    },
    setConfigurables(_configurables: { gcp: Configurables, 'mock-cloud': Configurables }) {
      this.configurables.gcp = _configurables.gcp;
      this.configurables['mock-cloud'] = _configurables['mock-cloud'];
      this.areConfigurablesReady = true;
    },
    setPlans(plans: Plan[]) {
      this.plans = plans;
    },
  },
  persist: true, // TODO(fb): Let's avoid caching for this part
});

// const selectedDeployment = ref<string>('');
//   const configurables: { gcp: Configurables, 'mock-cloud': Configurables } = reactive({
//     gcp: {
//       regions: [],
//       sizes: [],
//       features: [],
//       providers: [],
//     },
//     'mock-cloud': {
//       regions: [],
//       sizes: [],
//       features: [],
//       providers: [],
//     },
//   });
